// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconLayoutWindow25 = createRemixIcon('IconLayoutWindow25', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2 .75H.75v22.5h22.5V.75zm1.25 13.333V9.917h17.5v4.166zm0 2.5v4.167h17.5v-4.167z\" clip-rule=\"evenodd\"/>");
